import { safeLocalStorage } from '@/client/utils/SafeLocalStorage';
/*
 * Text and screen size: the whole page is scaled with CSS zoom.
 *
 * Installed as an app (home screen), the page has no browser menu to zoom or change the text size, and the game's
 * sizes are in pixels, so scaling only the text would break the layout.
 */
const KEY = 'tfm.uiScale';
export const UI_SCALES = [80, 90, 100, 110, 125, 150, 175];
export const DEFAULT_UI_SCALE = 100;
/** Sent on window when the size changes, so the settings dialog and the corner buttons agree. */
export const UI_SCALE_EVENT = 'tfm-ui-scale';
/** The size one step bigger (1) or smaller (-1), staying within the list. */
export function nextUiScale(scale, direction) {
    const scales = UI_SCALES;
    const index = scales.indexOf(scale);
    const from = index >= 0 ? index : scales.indexOf(DEFAULT_UI_SCALE);
    return scales[Math.max(0, Math.min(scales.length - 1, from + direction))];
}
export function getUiScale(storage = safeLocalStorage) {
    const value = Number(storage.getItem(KEY));
    return UI_SCALES.includes(value) ? value : DEFAULT_UI_SCALE;
}
export function applyUiScale(scale = getUiScale(), root = document.documentElement) {
    root.style.setProperty('zoom', scale === DEFAULT_UI_SCALE ? '' : String(scale / 100));
}
export function setUiScale(scale, storage = safeLocalStorage) {
    if (scale === DEFAULT_UI_SCALE) {
        storage.removeItem(KEY);
    }
    else {
        storage.setItem(KEY, String(scale));
    }
    applyUiScale(scale);
    window.dispatchEvent(new CustomEvent(UI_SCALE_EVENT, { detail: scale }));
}
